<app-page-title titleHeading='Cards examples 2' titleDescription='Wide selection of cards with multiple styles, borders, actions and hover effects.'></app-page-title>

<app-example-wrapper-seamless sectionHeading="Cards 8">
    <app-cards2-examples-8></app-cards2-examples-8>
</app-example-wrapper-seamless>
<app-example-wrapper-seamless sectionHeading="Cards 9">
    <app-cards2-examples-9></app-cards2-examples-9>
</app-example-wrapper-seamless>
<app-example-wrapper-seamless sectionHeading="Cards 10">
    <app-cards2-examples-10></app-cards2-examples-10>
</app-example-wrapper-seamless>
<app-example-wrapper-seamless sectionHeading="Cards 11">
    <app-cards2-examples-11></app-cards2-examples-11>
</app-example-wrapper-seamless>
<app-example-wrapper-seamless sectionHeading="Cards 12">
    <app-cards2-examples-12></app-cards2-examples-12>
</app-example-wrapper-seamless>
<app-example-wrapper-seamless sectionHeading="Cards 13">
    <app-cards2-examples-13></app-cards2-examples-13>
</app-example-wrapper-seamless>
<app-example-wrapper-seamless sectionHeading="Cards 14">
    <app-cards2-examples-14></app-cards2-examples-14>
</app-example-wrapper-seamless>

